import { Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';

type Props = {
  source: string;
  sx?: object;
};

const truncateSx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap' as const,
};

const AcceptanceArtifactLabelField = ({ source, sx }: Props) => {
  const { data } = useShowContext();
  const value = (data?.getValueBySource?.(source) as string | undefined) || '—';

  const content = (
    <Typography color="textPrimary" sx={{ ...truncateSx, ...sx }}>
      {value}
    </Typography>
  );

  return value !== '—' ? (
    <Tooltip title={value} placement="top">
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default AcceptanceArtifactLabelField;
